import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';

//ReactDOM.render(<h1>Keeper</h1>,document.getElementById("root"));
ReactDOM.render(<App/>,document.getElementById("root"));
